export const hasError = (error) =>
  Boolean(Object.keys(error).filter(key => error[key]).length)

export const emailIsValid = (email) =>
  (/^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email) //eslint-disable-line

export const validateRequired = (value, fieldName, text = '') =>
  ({ [`${fieldName}Error`]: value ? undefined : `จำเป็นต้องกรอกข้อมูล${text}` })

export const inputProps = (reduxField) =>
  ({ value: reduxField.value, onChange: reduxField.onChange })

export const allowNumberOnly = (field, allowZero = false, maxLength = 0) => ({
  value: field.value,
  onChange: (e) => ((value) => {
    let needChanged = true
    if (value === '') return field.onChange(value)

    value = parseInt(value, 10)
    if (value !== value) needChanged = false // eslint-disable-line
    else if (typeof (value) !== 'number') needChanged = false
    else if (!allowZero && value === 0) needChanged = false
    else if (maxLength && e.currentTarget.value.length > maxLength) needChanged = false

    if (needChanged) field.onChange(e.currentTarget.value)
  })(e.currentTarget.value === '' ? '' : parseInt(e.currentTarget.value.slice(-1), 10))
})

export const allowDateOnly = (field) => ({
  value: field.value,
  onChange: (e) => ((value) => {
    let allowChange = value.length <= 10
    allowChange = allowChange && value.split('').pop() !== '.' &&
      (
        (typeof (value.replace(/\//g, '') === 'number') && (value.split('').pop() !== '/' && value.length !== 3 && value.length !== 6)) ||
        (value.split('').pop() === '/' && (value.length === 3 || value.length === 6))
      )
    if (allowChange) field.onChange(value)
  })(e.currentTarget.value)
})

export const allowTimeOnly = (field) => ({
  value: field.value,
  onChange: (e) => ((value) => {
    const char = value.split('').pop()
    let allowChange = value.length <= 5
    allowChange = allowChange && typeof (value) === 'number' && (
      (value.length !== 3 && char !== '.') ||
      (value.length === 3 && char === '.')
    )
    if (allowChange) field.onChange(value)
  })(e.currentTarget.value)
})

export const resolveBackSlash = (value = '') =>
  (value || '').replace(/\\/g, '')



// WEBPACK FOOTER //
// ./src/helpers/formHelpers.js